import React, { useRef, useEffect } from 'react'
import { Container } from '@kogk/common'
import { AspectRatioBox, ButtonDep as Button } from '..'

type Props = {
  title: string
  text?: string
  link?: {
    text: string
    url: string
  }
  image: {
    url: string
    alt: string
  }
  video?: {
    url: string
  }
  initialDelay?: number
  gsap: any
  onRenderLink?: () => JSX.Element
}

const HeroEpic = ({ title, text, link, image, video, initialDelay = 0.5, gsap, onRenderLink }: Props) => {
  let vidRef: any = useRef(null)

  useEffect(() => {
    if (video?.url) {
      gsap.to(vidRef, {
        filter: 'brightness(1) contrast(1)',
        opacity: 1,
        ease: 'expo',
        duration: 3
      })
    }
    gsap.to('.text-anim-heading', {
      duration: 0.9,
      opacity: 1,
      y: 0,
      ease: 'expo',
      stagger: 0.3,
      delay: initialDelay + 0.3
    })
    gsap.to('.text-anim', {
      duration: 1,
      opacity: 1,
      y: 0,
      ease: 'expo',
      delay: initialDelay + 1
    })
    if (link) {
      gsap.to('.btn-anim', {
        duration: 0.7,
        opacity: 1,
        ease: 'power3',
        delay: initialDelay + 1.8
      })
    }
  }, [gsap, initialDelay, link, video])

  const splitUpHeading = (heading: string) => heading.split(' ')

  return (
    <div className='hero-epic'>
      {/* desktop start */}
      {video?.url ? (
        <div className='d-none d-lg-flex hero-epic__video-container col-lg-1 offset-lg-3 px-0'>
          <video
            ref={el => {
              vidRef = el
            }}
            autoPlay
            muted
            loop
            playsInline
            className='hero-epic__video'
            src={video.url}
          />
        </div>
      ) : (
        <div className='col-lg-6 offset-lg-6 px-0 hero-epic__video-container'>
          <img
            className='hero-header__gatsby-image-container image-rounded'
            alt={image?.alt || 'content image'}
            src={image.url}
          />
        </div>
      )}
      {/* desktop end */}

      <div className='d-block d-lg-none hero-epic__video-container '>
        {video?.url ? (
          <AspectRatioBox ratio='widescreen'>
            <video autoPlay muted loop playsInline className='hero-epic__video--mobile' src={video.url} />
          </AspectRatioBox>
        ) : (
          <></>
        )}
      </div>

      <Container>
        <div className='d-flex flex-column justify-content-center col-lg-8 h-100 pt-2 pt-lg-6 mb-3 mb-lg-0 pl-0 hero-epic__content'>
          {/* desktop start */}
          <div className='d-none d-lg-block'>
            <div>
              <h1 className='text-anim-heading'>
                {splitUpHeading(title)
                  .slice(0, 2)
                  .join(' ')}
              </h1>
            </div>
            <div className='mt-n1 mt-md-n2 overflow-hidden'>
              <h1 className='text-anim-heading'>{splitUpHeading(title).length > 2 && splitUpHeading(title)[2]}</h1>
            </div>
            <div className='overflow-hidden mt-n1 mt-md-n2'>
              <p className='text-anim'>{text}</p>
            </div>
          </div>
          {/* desktop end */}

          {/* mobile start */}
          <div className='d-block d-lg-none text-anim'>
            <h1>{title}</h1>
            <p>{text}</p>
          </div>
          {/* mobile end */}

          {onRenderLink ? (
            onRenderLink()
          ) : (
            <a href={link?.url ?? '/'}>
              <Button className='mt-3 mt-lg-5 btn-anim' type='primary' label={link?.text ?? 'Read more'} />
            </a>
          )}
        </div>
      </Container>
    </div>
  )
}

export default HeroEpic
